import React from 'react';
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';

const PopularityChart = ({ homes }) => {
  const calculatePopularity = (mealType) => {
    const mealCounts = {};
    Object.values(homes).forEach(home => {
      const preferences = home[`${mealType}_preferences`] || [];
      preferences.forEach(mealId => {
        mealCounts[mealId] = (mealCounts[mealId] || 0) + 1;
      });
    });

    return Object.entries(mealCounts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  };

  return (
    <div className="space-y-8">
      {['breakfast', 'lunch', 'dinner'].map(mealType => (
        <div key={mealType} className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-xl font-semibold mb-4 capitalize">{mealType} Popularity</h3>
          <div className="overflow-x-auto">
            <BarChart
              width={800}
              height={Math.max(300, calculatePopularity(mealType).length * 30)}
              data={calculatePopularity(mealType)}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 200, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis
                type="category"
                dataKey="name"
                width={180}
                tick={{ fontSize: 12 }}
              />
              <Tooltip />
              <Bar dataKey="count" fill="#8884d8" />
            </BarChart>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PopularityChart;